import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus, { ElMessage } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import { createErrorReporter, installGlobalErrorHandlers } from './services/error-feedback';
import './styles.css';
const app = createApp(App);
app.use(createPinia());
app.use(router as any);
// 组件库统一中文：表格空态（No Data→暂无数据）、分页器（Total/Go to/page→共 X 条/前往/页）
// 都来自 Element Plus 的语言包，注入 zh-cn 即可，无需逐页改文案。
app.use(ElementPlus as any, { locale: zhCn });
// 统一错误提示：页面漏 catch 的写操作（try/finally 无 catch）与未处理 Promise 拒绝都会在这里提示，
// 已自行 catch 并提示的页面不会重复弹出。
const reportError = createErrorReporter({ notify: message => ElMessage.error(message) });
installGlobalErrorHandlers(reportError, {
  config: app.config as any,
  addEventListener: (type, listener) => window.addEventListener(type as any, listener as any),
});
app.mount('#app');
